import { users } from "@api/users/path";
import { files } from "@api/files/path";
import { selectTypes } from "@api/selectTypes/path";
import { geo } from "@api/geo/path";
import { auth } from "@api/auth/path";
import { subjects } from "@api/subjects/path";
import { courses } from "@api/courses/path";
import { sessions } from "@api/sessions/path";
import { enrollments } from "@api/enrollments/path";
import { courseReviews } from "@api/reviews/path";
import { notifications } from "@api/notifications/path";
import { channels } from "@api/channels/path";
import { conversations } from "@api/conversations/path";
import { interactiveExams } from "@api/interactiveExams/path";
import { fileBasedExams } from "@api/fileBasedExams/path";
import { exams } from "@api/exams/path";
import { contactMessages } from "@api/contactMessages/path";
import { blogPosts } from "@api/blogPosts/path";

export const path = {
  users,
  files,
  selectTypes,
  geo,
  auth,
  subjects,
  courses,
  sessions,
  enrollments,
  courseReviews,
  notifications,
  channels,
  conversations,
  interactiveExams,
  fileBasedExams,
  exams,
  contactMessages,
  blogPosts,
};
